import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import DashboardEvent from "../event/DashboardEvent";

export default class DashboardScreenMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {RevisableLanguagePack} languagePack 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack, mediatorManager, progressGameModel) {
        super(target, dispatcher, layoutManager, clickEaterFactory);
        this._mediatorManager = mediatorManager;
        this._languagePack = languagePack;
        this._progressGameModel = progressGameModel;
    }

    initialize() {
        super.initialize();
        this.preventClickThrough();

        const week = this._progressGameModel.week;

        this._dashboardEpiMediator = this._mediatorManager.createMediator(this._target.DashboardTab1, SkinKeyRegistry.DASHBOARD_EPI_TAB_SKIN);
        this._dashboardHealthSystemsMediator = this._mediatorManager.createMediator(this._target.DashboardTab2, SkinKeyRegistry.DASHBOARD_HEALTH_SYSTEMS_TAB_SKIN);
        this._dashboardRCCEMediator = this._mediatorManager.createMediator(this._target.DashboardTab3, SkinKeyRegistry.DASHBOARD_RCCE_TAB_SKIN);

        if (this._target.closeButton != null) {
            this._closeButton = this.createButton(this._target.closeButton, this._handleCloseButton.bind(this));
        }

        if (this._target.TabButton1 != null) {
            this._tabEpiButton = this.createButton(this._target.TabButton1, this._handleTabEpiButton.bind(this), this._languagePack.getText(`dashboard.mainScreen.buttonEpiTab`));
        }

        if (this._target.TabButton2 != null) {
            this._tabHealthSystemsButton = this.createButton(this._target.TabButton2, this._handleTabHealthSystemsButton.bind(this), this._languagePack.getText(`dashboard.mainScreen.buttonHealthSystemsTab`));
        }

        if (this._target.TabButton3 != null) {
            this._tabRCCEButton = this.createButton(this._target.TabButton3, this._handleTabRCCE.bind(this), this._languagePack.getText(`dashboard.mainScreen.buttonRCCETab`));
        }

        this._target.TitleExtraBoldTextField.text = this._languagePack.getText(`dashboard.mainScreen.mainTitle`);
        this._target.TitleLightTextField.text = this._languagePack.getText(`dashboard.mainScreen.secondaryTitle`);

        this._target.TitleSubTextField.text = this._languagePack.getText(`dashboard.mainScreen.subTitle`) + " " + week;

        this._handleTabEpiButton();

        this._target.DashboardTab1.LabelTab1Color.alpha = 0;
        this._target.DashboardTab2.LabelTab2Color.alpha = 0;

        this._target.DashboardTab1.Annotation1.alpha = 0;
        this._target.DashboardTab1.Annotation2.alpha = 0;
        this._target.DashboardTab2.Annotation3.alpha = 0;
        this._target.DashboardTab2.GlobeEpilogue.alpha = 0;

        this._updateTabNotifications();
    }
    destroy() {
        super.destroy();
        this._dashboardEpiMediator.destroy();
        this._dashboardHealthSystemsMediator.destroy();
        this._dashboardRCCEMediator.destroy();
        this._closeButton = null;
    }

    _updateTabNotifications() {
        if (this._target.TabNewIndicator1 !== undefined) {
            this._target.TabNewIndicator1.alpha = 0;
        }

        if (this._target.TabNewIndicator2 !== undefined && !this._progressGameModel.updatedDashboardData) {
            this._target.TabNewIndicator2.alpha = 0;
        }
        if (this._target.TabNewIndicator3 !== undefined && !this._progressGameModel.updatedDashboardRCCE) {
            this._target.TabNewIndicator3.alpha = 0;
        }
    }

    _handleCloseButton() {
        this.dispatch(DashboardEvent.CLOSE_SCREEN_REQUEST);
    }


    _handleTabEpiButton() {
        this._dashboardEpiMediator.show();
        this._dashboardHealthSystemsMediator.hide();
        this._dashboardRCCEMediator.hide();

        if (this._tabEpiButton != null) {
            this._tabEpiButton.setSelected(true);
            this._tabEpiButton.setFocus(true);
        }

        if (this._tabHealthSystemsButton != null) {
            this._tabHealthSystemsButton.setSelected(false);
            this._tabHealthSystemsButton.setFocus(false);
        }

        if (this._tabRCCEButton != null) {
            this._tabRCCEButton.setSelected(false);
            this._tabRCCEButton.setFocus(false);
        }
    }

    _handleTabHealthSystemsButton() {
        this._dashboardEpiMediator.hide();
        this._dashboardHealthSystemsMediator.show();
        this._dashboardRCCEMediator.hide();

        if (this._tabEpiButton != null) {
            this._tabEpiButton.setSelected(false);
            this._tabEpiButton.setFocus(false);
        }

        if (this._tabHealthSystemsButton != null) {
            this._tabHealthSystemsButton.setSelected(true);
            this._tabHealthSystemsButton.setFocus(true);
        }

        if (this._tabRCCEButton != null) {
            this._tabRCCEButton.setSelected(false);
            this._tabRCCEButton.setFocus(false);
        }

        this._progressGameModel.updatedDashboardData = false;
        this._updateTabNotifications();
    }

    _handleTabRCCE() {
        this._dashboardEpiMediator.hide();
        this._dashboardHealthSystemsMediator.hide();
        this._dashboardRCCEMediator.show();

        this._tabEpiButton.setSelected(false);
        this._tabEpiButton.setFocus(false);

        this._tabHealthSystemsButton.setSelected(false);
        this._tabHealthSystemsButton.setFocus(false);

        this._tabRCCEButton.setSelected(true);
        this._tabRCCEButton.setFocus(true);

        this._progressGameModel.updatedDashboardRCCE = false;
        this._updateTabNotifications();
    }

}